export const VEHICLE_STATUS = ["ไม่มีเจ้าของ", "มีเจ้าของแล้ว"];